import React from 'react';
import { Link as GatsbyLink } from 'gatsby';

import AppContext from 'AppContext';

/**
 * Link.
 *
 * Modified Gatsby link for local urls.
 * @see https://www.gatsbyjs.org/docs/gatsby-link/ for props and details.
 */
const Link = ( { children, className, target, to, ...gatsbyProps } ) => {

  const AppState = React.useContext( AppContext );
  let modifiedTo = to;

  if(
    target === '_blank' ||
    to.includes( 'http' ) ||
    to.includes( 'tel:' ) ||
    to.includes( 'mailto:' )
  ) {

    return(
      <a
      className={ className }
      href={ to }
      target={ target }
      rel="noopener noreferrer"
      { ...gatsbyProps }
      >
        { children }
      </a>
    );

  }


  return(

    <GatsbyLink
    className={ className }
    to={ to }
    { ...gatsbyProps }
    >
      { children }
    </GatsbyLink>

  );

}
export default Link;